export default __webpack_public_path__ + "static/Bonnie-f9fa02022476f1490cdf97b7de29f22b.png";